<template>
  <v-card elevation="2" outlined class="mx-auto">
    <base-expansion-panel :inputs="minyukinAnkenLists.inputs" :reactiveVar="reactiveVar">
      <base-form
        :searchBtn="true"
        :resetBtn="true"
        :inputs="minyukinAnkenLists.inputs"
        :reactiveVar="reactiveVar"
        @submit-form="getDataMinyukinAnkenItemsActions()"
      >
      </base-form>
    </base-expansion-panel>
    <base-table
      :headers="minyukinAnkenLists.headers"
      :items="baseFilteredItems ?? minyukinAnkenItems"
      :columnName="[
        'item.bikou',
        'item.total_quantity',
        'item.total_weight',
        'item.base_name',
        'item.shipment_pending_flag',
        'item.edit',
      ]"
      :itemKey="itemKey"
      :itemClass="itemClass"
      multiSort
    >
      <template v-slot:[`item.bikou`]="{ item }">
        <v-textarea
          v-if="item.editing"
          filled
          hide-details="true"
          :value="item.bikou"
          @change="editMinyuukinAnkenItemsActions([{ packing_no: item.packing_no, new_bikou: $event }])"
        ></v-textarea>
        <span class="wrap-text" v-else>{{ item.bikou }}</span>
      </template>
      <template v-slot:[`item.total_quantity`]="{ item }">
        <td style="text-align: right">
          <span v-if="item.total_quantity != null">{{ item.total_quantity.commaString() }}</span>
        </td>
      </template>
      <template v-slot:[`item.total_weight`]="{ item }">
        <td style="text-align: right">
          <span v-if="item.total_weight != null">{{ item.total_weight.commaString(' kg') }}</span>
        </td>
      </template>
      <template v-slot:[`item.base_name`]="{ item }">
        <td style="min-width: 120px; text-align: center">
          <span v-if="item.base_name != null">{{ item.base_name }} </span>
        </td>
      </template>
      <template v-slot:[`item.shipment_pending_flag`]="{ item }">
        <v-row>
          <v-col class="d-flex justify-center">
            <lazy>
              <v-checkbox
                v-if="item.editing"
                class="mt-0 pt-0"
                color="primary"
                :input-value="item.shipment_pending_flag"
                dense
                hide-details
                :key="item.shipment_pending_flag"
                @change="
                  editMinyuukinAnkenItemsActions([
                    {
                      packing_no: item.packing_no,
                      new_shipment_pending_flag: $event,
                    },
                  ])
                "
              ></v-checkbox>
              <v-checkbox
                v-else
                class="mt-0 pt-0"
                color="primary"
                :input-value="item.shipment_pending_flag"
                dense
                hide-details
                disabled
              ></v-checkbox>
            </lazy>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <lazy>
          <div v-if="role">
            <v-btn
              v-if="item.editing"
              text
              icon
              color="green lighten-2"
              @click="
                updateMinyuukinAnkenItemsActions([
                  {
                    packingNo: item.packing_no,
                    bikou: item.new_bikou,
                    shipmentPendingFlag: item.new_shipment_pending_flag,
                  },
                ])
              "
            >
              <v-icon large>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              v-else
              text
              icon
              color="blue lighten-2"
              @click="editMinyuukinAnkenItemsActions([{ packing_no: item.packing_no, editing: true }])"
            >
              <v-icon large>mdi-pencil-box</v-icon>
            </v-btn>
            <v-btn
              v-if="item.editing"
              text
              icon
              color="red lighten-2"
              @click="
                editMinyuukinAnkenItemsActions([
                  {
                    packing_no: item.packing_no,
                    editing: false,
                    new_bikou: item.bikou,
                    new_shipment_pending_flag: item.shipment_pending_flag,
                  },
                ])
              "
            >
              <v-icon large>mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </lazy>
      </template>
    </base-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Payload from '../components/customs/payload.js';
export default {
  name: 'MinyukinAnkenLists',
  components: {
    lazy: () => import(/* webpackChunkName: "Lazy" */ '@/components/ui/Lazy.vue'),
  },
  data() {
    return {
      itemKey: 'packing_no',
      role: false,
      baseFilteredItems: null,
    };
  },
  computed: {
    ...mapGetters({
      minyukinAnkenLists: 'defined/minyukinAnkenLists',
      reactiveVar: 'minyukinAnken/reactiveVar',
      minyukinAnkenItems: 'minyukinAnken/minyukinAnkenItems',
      path: 'defined/pathNames',
      user: 'defined/user',
      currentBases: 'base/currentBases',
      baseList: 'base/baseList',
    }),
  },
  async created() {
    this.role = await this.getRole({
      page: this.path.MINYUKIN_ANKEN_LISTS,
      authority: this.user.authority,
    });
    await this.getDataMinyukinAnkenItemsActions();
  },
  methods: {
    ...mapActions({
      getDataMinyukinAnkenItemsActions: 'minyukinAnken/getDataMinyukinAnkenItemsActions',
      editMinyuukinAnkenItemsActions: 'minyukinAnken/editMinyuukinAnkenItemsActions',
      updateMinyuukinAnkenItemsActions: 'minyukinAnken/updateMinyuukinAnkenItemsActions',
      getRole: 'common/getRole',
    }),
    itemClass(item) {
      if (item.editing) {
        return 'highlight-green not-change-hover-color';
      }
      return '';
    },
    async getDataMinyukinAnkenItemsActions() {
      const baseIdList = this.baseList.filter((base) => base.id !== 0).map((base) => base.id);
      const payload = { ...this.reactiveVar, baseIdList };
      const params = new Payload('search-unpaid-packings', 'minyukinAnken/setMinyukinAnkenItemsActions', '', payload)
        .data;
      await this.$store.dispatch('api/callAPI', params, { root: true });
    },
    baseFilter() {
      this.baseFilteredItems = this.minyukinAnkenItems.filter((item) => {
        const baseIds = this.currentBases.map((base) => base.id);
        const res = baseIds.includes(item.base_id);
        return res;
      });
    },
  },
  watch: {
    currentBases() {
      this.baseFilter();
    },
    minyukinAnkenItems(minyukinAnkenItems) {
      if (this.currentBases.length > 0) {
        this.baseFilter();
      } else {
        this.baseFilteredItems = minyukinAnkenItems;
      }
    },
  },
};
</script>
<style>
.wrap-text {
  white-space: pre;
}
</style>
